// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lsn-upload .lsn-document-container {
  width: 100%;
  max-width: 780px !important;
}
.lsn-upload .lsn-upload-view-attachment {
  white-space: nowrap;
}
.lsn-upload .lsn-dropzone-overlay {
  width: 100%;
  height: 200px;
  border-width: 2px;
  border-color: var(--main-primary-color);
  border-style: dashed;
  border-radius: var(--main-control-border-radius);
  display: flex;
  flex-direction: column;
  justify-content: center;
  row-gap: 0.3rem;
  position: relative;
}
.lsn-upload .lsn-dropzone-overlay .lsn-upload-link {
  display: flex;
  column-gap: 0.5rem;
  justify-content: center;
}
.lsn-upload .lsn-dropzone-overlay .lsn-upload-link path {
  fill: var(--main-primary-color);
}
.lsn-upload .lsn-dropzone-overlay input {
  position: absolute;
  bottom: 0;
  width: 1px;
  left: 50%;
}
.lsn-upload .lsn-upload-display-container {
  width: 100%;
  max-width: 440px !important;
  border: var(--main-border-width) solid var(--main-border-color) !important;
  height: 115px;
  margin: auto;
  margin-top: 40px;
  background-color: var(--main-bg-color-lighter);
  display: grid;
  grid-row: auto;
  grid-template-columns: 56px auto;
  padding: 16px 25px 25px 36px;
  align-items: center;
}
.lsn-upload .lsn-upload-display-details {
  text-overflow: ellipsis;
  overflow: hidden;
}
.lsn-upload .lsn-upload-display-details a {
  font-size: 18px !important;
  white-space: nowrap;
}
.lsn-upload .lsn-upload-display-details span {
  margin-right: 30px;
}
.lsn-upload .lsn-dropzone-overlay {
  margin-top: 1rem;
  cursor: pointer;
}
.lsn-upload .lsn-dropzone-overlay:hover {
  background-color: color-mix(in srgb, var(--main-primary-color) 5%, transparent);
}
.lsn-upload .lsn-remove-link {
  color: var(--main-red) !important;
}
.lsn-upload .fa-file-alt {
  font-size: 3rem;
}
.lsn-upload .lsn-input-error {
  display: list-item;
  margin: 1rem !important;
  color: var(--main-red);
  -webkit-animation: gl_flash 2s;
  animation: gl_flash 2s;
}
.lsn-upload.has-error .lsn-dropzone-overlay {
  background-color: color-mix(in srgb, var(--main-red) 5%, var(--main-white));
}
.lsn-upload.has-error .lsn-dropzone-overlay {
  border-color: var(--main-red) !important;
}
.lsn-upload.has-error .lsn-dropzone-overlay * {
  color: var(--main-red) !important;
  fill: var(--main-red) !important;
}
`, "",{"version":3,"sources":["webpack://./src/pages/recommendationForm/QuestionBlock/components/UploadDocument.less"],"names":[],"mappings":"AAAA;EAEI,WAAA;EACA,2BAAA;AAAJ;AAHA;EAOI,mBAAA;AADJ;AANA;EAWI,WAAA;EACA,aAAA;EACA,iBAAA;EACA,uCAAA;EACA,oBAAA;EACA,gDAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;AAFJ;AAnBA;EAwBM,aAAA;EACA,kBAAA;EACA,uBAAA;AAFN;AAxBA;EA6BQ,+BAAA;AAFR;AA3BA;EAkCM,kBAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;AAJN;AAjCA;EA0CI,WAAA;EACA,2BAAA;EACA,0EAAA;EACA,aAAA;EACA,YAAA;EACA,gBAAA;EACA,8CAAA;EACA,aAAA;EACA,cAAA;EACA,gCAAA;EACA,4BAAA;EACA,mBAAA;AANJ;AA/CA;EAyDI,uBAAA;EACA,gBAAA;AAPJ;AAnDA;EA6DM,0BAAA;EACA,mBAAA;AAPN;AAvDA;EAkEM,kBAAA;AARN;AA1DA;EAuEI,gBAAA;EACA,eAAA;AAVJ;AAYI;EACE,+EAAA;AAVN;AAjEA;EAgFI,iCAAA;AAZJ;AApEA;EAoFI,eAAA;AAbJ;AAvEA;EAwFI,kBAAA;EACA,uBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sBAAA;AAdJ;AAiBE;EAEI,2EAAA;AAhBN;AAcE;EAMI,wCAAA;AAjBN;AAWE;EASM,iCAAA;EACA,gCAAA;AAjBR","sourcesContent":[".lsn-upload {\n  .lsn-document-container {\n    width: 100%;\n    max-width: 780px !important;\n  }\n\n  .lsn-upload-view-attachment {\n    white-space: nowrap;\n  }\n\n  .lsn-dropzone-overlay {\n    width: 100%;\n    height: 200px;\n    border-width: 2px;\n    border-color: var(--main-primary-color);\n    border-style: dashed;\n    border-radius: var(--main-control-border-radius);\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    row-gap: .3rem;\n    position: relative;\n\n    .lsn-upload-link {\n      display: flex;\n      column-gap: .5rem;\n      justify-content: center;\n\n      path {\n        fill: var(--main-primary-color);\n      }\n    }\n\n    input {\n      position: absolute;\n      bottom: 0;\n      width: 1px;\n      left: 50%;\n    }\n  }\n\n  .lsn-upload-display-container {\n    width: 100%;\n    max-width: 440px !important;\n    border: var(--main-border-width) solid var(--main-border-color) !important;\n    height: 115px;\n    margin: auto;\n    margin-top: 40px;\n    background-color: var(--main-bg-color-lighter);\n    display: grid;\n    grid-row: auto;\n    grid-template-columns: 56px auto;\n    padding: 16px 25px 25px 36px;\n    align-items: center;\n  }\n\n  .lsn-upload-display-details {\n    text-overflow: ellipsis;\n    overflow: hidden;\n\n    a {\n      font-size: 18px !important;\n      white-space: nowrap;\n    }\n\n    span {\n      margin-right: 30px;\n    }\n  }\n\n  .lsn-dropzone-overlay {\n    margin-top: 1rem;\n    cursor: pointer;\n\n    &:hover {\n      background-color: color-mix(in srgb, var(--main-primary-color) 5%, transparent);\n    }\n  }\n\n  .lsn-remove-link {\n    color: var(--main-red) !important;\n  }\n\n  .fa-file-alt {\n    font-size: 3rem;\n  }\n\n  .lsn-input-error {\n    display: list-item;\n    margin: 1rem !important;\n    color: var(--main-red);\n    -webkit-animation: gl_flash 2s;\n    animation: gl_flash 2s;\n  }\n\n  &.has-error {\n    .lsn-dropzone-overlay {\n      background-color: color-mix(in srgb, var(--main-red) 5%, var(--main-white));\n    }\n\n    .lsn-dropzone-overlay {\n      border-color: var(--main-red) !important;\n\n      * {\n        color: var(--main-red) !important;\n        fill: var(--main-red) !important;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
